module.exports = __webpack_public_path__ + "static/typewriter2-05be38dcb326f256cadf8769a7a8fbc1.png";